import { TranslateService } from '@ngx-translate/core';
import { AllInputTypes, FormInputConfig, ListValues } from '../../../../../trash/shared/interfaces/form-input-config';
import { ISpecializedRoleResponse, IUpdateSpecializedRolesRequest } from '../dtos';
import { getIdFormConfig } from '../../../../../views/pages/adminstration/temp-common/utils';
import { Validators } from '@angular/forms';

export class UpdateRoleModel implements IUpdateSpecializedRolesRequest {
  id?: string;
  name: string;

  private constructor(request: IUpdateSpecializedRolesRequest) {
    this.id = request.id;
    this.name = request.name;
  }

  static create(request: IUpdateSpecializedRolesRequest): UpdateRoleModel {
    return new UpdateRoleModel(request);
  }

  static createDefault(): UpdateRoleModel {
    return UpdateRoleModel.create({
      id: '',
      name: '',
    });
  }

  static createFromItem(item: ISpecializedRoleResponse): UpdateRoleModel {
    return new UpdateRoleModel({
      id: item.id,
      name: item.englishName,
    });
  }

  getFormConfig(roles: ListValues[], isVisible?: boolean, translate?: TranslateService): FormInputConfig[] {
    return [
      getIdFormConfig(this.id),
      {
        type: AllInputTypes.Text,
        name: 'name',
        label: translate?.instant('GENERAL.NAME'),
        placeholder: `${translate?.instant('GENERAL.ENTER')} ${translate?.instant('GENERAL.NAME')}`,
        defaultValue: this.name,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [{ function: Validators.required, errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('GENERAL.NAME')}` }]
      },
    ];
  }
}
